


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Constants
import Constants from '@/constants/constants';

// Components
import Card, { CardDecorationColor, CardNumber } from '@/shared/components/card.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Tooltip, { TooltipColor } from '@/shared/components/Tooltip.component.vue';

// Filters
import formatDate from '@/shared/filters/formatDate.filter.ts';

// Services
import { ConvocationService, TypeOfProduct } from '@/manager/convocation/convocation.service';

// Exports
export { CardDecorationColor, CardNumber };

@Component({
    components: {
        Card,
        Icon,
        Tooltip,
    },
    filters: {
        formatDate,
    },
})
export default class ConvocationCard extends Vue {
    @Prop() private convocation!: any;
    // Base component props
    @Prop({ default: CardDecorationColor.Primary }) private cardDecorationColor!: string;
    @Prop({ default: CardNumber.Even }) private cardNumber!: string;


    private iconEnum = IconEnum;
    private tooltipColor = TooltipColor;


    get trainer() {
        let result = 'Sin formador asignado';
        if (this.convocation.trainer && this.convocation.trainer.firstName) {
            result = `${this.convocation.trainer.firstName} ${this.convocation.trainer.lastName}`;
        }
        return result;
    }

    get eventManager() {
        let result = 'Sin event manager asignado';
        if (this.convocation.eventManager && this.convocation.eventManager.firstName) {
            result = `${this.convocation.eventManager.firstName} ${this.convocation.eventManager.lastName}`;
        }
        return result;
    }

    get expander() {
        let result = 'Sin expansor asignado';
        if (this.convocation.expander && this.convocation.expander.firstName) {
            result = `${this.convocation.expander.firstName} ${this.convocation.expander.lastName}`;
        }
        return result;
    }

    get isConference() {
        return ConvocationService.convocationIsProductType(this.convocation, TypeOfProduct.Conference);
    }

    get convocationKpis() {
        const salesMoney = this.convocation.totalParticipantSalesMoney || 0;
        const amountItemsSold = this.convocation.totalParticipantAmountItemsSold || 0;
        const potentials = this.convocation.totalParticipantPotential || 0;
        const salesConversionRation = this.convocation.totalParticipantSalesConversionRatio || 0;

        const kpis = [
            {
                icon: IconEnum.Participant,
                iconColor: 'color-secondary',
                value: this.convocation.totalParticipantSummoned,
                text: 'Clientes convocados',
            }, {
                icon: IconEnum.Price,
                iconColor: 'color-secondary',
                value: `${salesMoney}€`,
                text: 'Importe de ventas',
            }, {
                icon: IconEnum.Participant,
                iconColor: 'color-primary',
                value: this.convocation.totalParticipantChecked,
                text: 'Clientes registrados',
            }, {
                icon: IconEnum.ShoppingCart,
                iconColor: 'color-primary',
                value: `${amountItemsSold} uds`,
                text: 'Nº de ventas',
            }, {
                icon: IconEnum.TargetClient,
                iconColor: 'color-secondary',
                value: potentials,
                text: 'Clientes potenciales',
            }, {
                icon: IconEnum.Price,
                iconColor: 'color-primary',
                value: `RC ${salesConversionRation}%`,
                text: 'Ratio de conversión de ventas',
            },
        ];
        return kpis;
    }

    get convocationProductName() {
        let result = 'No product';
        if ( this.convocation.product !== null) {
            result = this.convocation.product.name;
        }
        return result;
    }

    get cardSecondSubtitleLabel() {
        let label = 'EM';

        if ( this.isConference ) {
            label = 'EX';
        }

        return label;
    }

    get cardSecondSubtitleValue() {
        let label = this.eventManager;

        if ( this.isConference ) {
            label = this.expander;
        }

        return label;
    }

    get convocationDate() {
        let date = '';
        if ( this.convocation.timetables[0] !== undefined ) {
            date = this.convocation.timetables[0].date;
        }
        return date;
    }

    get convocationTimeStart() {
        let timeStart = '';
        if ( this.convocation.timetables[0] !== undefined ) {
            timeStart = this.convocation.timetables[0].timeStart;
        }
        return timeStart;
    }

    get convocationLocation() {
        let location = this.convocation.location.name;
        if ( this.convocation.openDelegation ) {
            location = Constants.delegationNotConfirmed;
        }
        return location;
    }


    private hour(hour: string) {
        const hourSplit = hour.split(':');
        let finalHour = `${hourSplit[0]}:${hourSplit[1]} h`;
        if ( this.convocation.openDate ) {
            finalHour = Constants.openDate;
        }
        return finalHour;
    }
}

